let isProsePanicked = false;

export const setProsePanicked = (value: boolean): void => {
  isProsePanicked = value;
};

export const getProsePanicked = (): boolean => isProsePanicked;
